<mbs-modal [isCustomModal]="true"
           [title]="'wizards:retention.GFSModal.title' | i18next">
  <ng-container modal-body
                [formGroup]="form">
    <mbs-form-group>
      <ng-container *ngTemplateOutlet="retentionInfo"></ng-container>
      <ng-container *ngTemplateOutlet="GFSBlock"></ng-container>
      <ng-container *ngTemplateOutlet="objectLockBlock"></ng-container>

      <ng-template #retentionInfo>
        <div class="mt-2 mb-2">
          <span class="fa fa-info-circle mr-2 cursor-help text-info"
                container="body"
                tooltipClass="tooltip-xl"
                [placement]="'right'"
                [ngbTooltip]="'wizards:retention.advancedSchedule.retentionPeriodTooltip' | i18next"></span>
          <strong>{{ 'wizards:retention.GFSModal.currentRetention' | i18next }}</strong>
          <span>&nbsp;{{ this.currentRetentionInfo }}</span>
        </div>
      </ng-template>

      <ng-template #GFSBlock>
        <div>
          <h5>{{ 'wizards:retention.GFSModal.GFSBlockTitle' | i18next }}</h5>
          <!-- Weekly -->
          <mbs-form-group>
            <div class="row mt-3"
                 formGroupName="weekly">
              <div class="col-7 pr-0">
                <mbs-checkbox formControlName="enabled"
                              [class]="'mr-n3'"
                              [label]="'wizards:retention.GFSModal.weeklyCheckbox' | i18next"
                              (change)="fullBackupsChangeHandler($event, 'weekly')"></mbs-checkbox>
              </div>
              <div class="col-3 mt-n1 pl-4">
                <mbs-number formControlName="storePeriod"
                            min="1"
                            max="100000"
                            [id]="elementSelectors.id.weeklyPeriodInput"></mbs-number>
              </div>
              <div class="col-auto">
                <mbs-input-label [label]="labels.weeks"></mbs-input-label>
              </div>
            </div>
            <div *ngIf="GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.invalid"
                 class="row mb-2">
              <div class="col-7 offset-5">
                <mbs-input-errors [errors]="[{ message: weeksErrors}]"></mbs-input-errors>
              </div>
            </div>
          </mbs-form-group>
          <!-- Monthly -->
          <mbs-form-group>
            <div class="row mt-3"
                 formGroupName="monthly">
              <div class="col-7 pr-0">
                <mbs-checkbox formControlName="enabled"
                              [class]="'mr-n3'"
                              [label]="'wizards:retention.GFSModal.monthlyCheckbox' | i18next"
                              (change)="fullBackupsChangeHandler($event, 'monthly')"></mbs-checkbox>
              </div>
              <div class="col-3 mt-n1 pl-4">
                <mbs-number formControlName="storePeriod"
                            min="1"
                            max="10000"
                            [id]="elementSelectors.id.monthlyPeriodInput"
                            (change)="monthlyStorePeriodChangeHandler()"></mbs-number>
              </div>
              <div class="col-auto">
                <mbs-input-label [label]="labels.months"></mbs-input-label>
              </div>
            </div>
            <div *ngIf="GFSPolicySettingsCtrl?.controls?.monthly?.controls?.storePeriod?.invalid"
                 class="row mb-2">
              <div class="col-7 offset-5">
                <mbs-input-errors [errors]="[{ message: monthsErrors}]"></mbs-input-errors>
              </div>
            </div>
          </mbs-form-group>
          <!-- Yearly -->
          <mbs-form-group>
            <div formGroupName="yearly">
              <div class="row mt-3">
                <div class="col-7 pr-0">
                  <mbs-checkbox formControlName="enabled"
                                [class]="'mr-n3'"
                                [label]="'wizards:retention.GFSModal.yearlyCheckbox' | i18next"
                                (change)="fullBackupsChangeHandler($event, 'yearly')"></mbs-checkbox>
                </div>
                <div class="col-3 mt-n1 pl-4">
                  <mbs-number formControlName="storePeriod"
                              min="1"
                              max="1000"
                              [id]="elementSelectors.id.yearlyPeriodInput"
                              (change)="yearlyStorePeriodChangeHandler()"></mbs-number>
                </div>
                <div class="col-auto">
                  <mbs-input-label [label]="labels.years"></mbs-input-label>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-8 pr-0">
                  <mbs-input-label [label]="'wizards:retention.GFSModal.yearlyStartLabel' | i18next"></mbs-input-label>
                </div>
                <div class="col-4 mt-n1">
                  <mbs-select formControlName="takeBackupFromMonth"
                              [id]="elementSelectors.id.yearlyFirstMonth"
                              [dropdownPosition]="'top'"
                              [bindValue]="'value'"
                              [bindLabel]="'label'"
                              [items]="monthNames"
                              [clearable]="false"
                              [searchable]="false"></mbs-select>
                </div>
              </div>
            </div>
          </mbs-form-group>
          <div *ngIf="retentionPeriodAlert.weekly || retentionPeriodAlert.monthly || retentionPeriodAlert.yearly"
               [id]="elementSelectors.id.retentionPeriodAlert">
            <mbs-alert [type]="mbsPopupType.danger"
                       [icon]="true"
                       [class]="'mt-2'">
              {{ 'wizards:retention.GFSModal.currentRetentionAlert' | i18next }}
            </mbs-alert>
          </div>
        </div>
      </ng-template>

      <ng-template #objectLockBlock>
        <div>
          <h5>
            {{ 'wizards:retention.objectLock' | i18next }}
            <span class="fa fa-info-circle ml-2 cursor-help text-info"
                  container="body"
                  tooltipClass="tooltip-xl"
                  [placement]="'right'"
                  [ngbTooltip]="'wizards:retention.GFSModal.objectLockTooltip' | i18next"></span>
          </h5>
          <mbs-checkbox formControlName="enabledImmutability"
                        [label]="'wizards:retention.GFSModal.objectLockCheckbox' | i18next"
                        (change)="enableImmutabilityChangeHandler($event)"></mbs-checkbox>
        </div>
        <div *ngIf="!canShowImmutabilityByStorage"
             [id]="elementSelectors.id.objectLockAlert"
             class="mt-3 mb-n3">
          <mbs-alert [type]="mbsPopupType.warning"
                     [icon]="true">
            {{ 'wizards:retention.GFSModal.immutabilityAlert' | i18next }}
            <a *ngIf="ability.can('read', 'HelpMarketing')"
               routerLink="/AP/Help/backup/about/gfs/immutability" target="_blank">
              {{'wizards:learn_more_link' | i18next}}
            </a>
          </mbs-alert>
        </div>
      </ng-template>
    </mbs-form-group>
  </ng-container>

  <ng-container modalFooter>
    <button type="button"
            class="btn btn-primary"
            [disabled]="form.invalid"
            [attr.data-test-element]="elementSelectors.id.saveButton"
            (click)="saveClickHandler()">
      {{ 'shared:buttons.save' | i18next: { format: 'title' } }}
    </button>
    <button type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            [attr.data-test-element]="elementSelectors.id.cancelButton"
            (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </button>
  </ng-container>
</mbs-modal>
